import { NavMenuListCombinedProps } from './types';

const usePresenter = (props: NavMenuListCombinedProps): NavMenuListCombinedProps => {
  return props;
};

export default usePresenter;
